import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {Outsourced} from "../../Outsourced";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SymbolArgs} from "../../reels/symbols/OutsourcedSymbol";
import {OutsourcedSound} from "../../sound/OutsourcedSound";
import {BrickSnake2000ReelSet} from "../../server/BrickSnake2000ReelSet";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreeSpinsOutro implements SimplePresentation {

    name:string = "FreesSpinOutro";

    constructor() {

    }

    public shouldRun():boolean {
        const mode = Outsourced.model.data.mode;
        const nextMode = Outsourced.model.data.nextMode;
        //return //!BrickSnake2000.model.gameData.brokeTheBank &&
        return !Outsourced.model.data.brokeTheBank &&
               (nextMode == "UPGRADE_BET" || nextMode == "NORMAL") &&
               (mode == GameMode.FREESPIN || mode == "FREESPIN_RESPIN") &&
               Outsourced.model.data.upgradeBetCount == 0;
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        const wasSfs = Outsourced.model.data.freespinsPlayed == 5;

        tl.add(() => {
            controller.setSkipCallback(() => {tl.seek("SKIP_OUTRO", false)});
        });
        tl.add(() => {
            Outsourced.keypadPlugin.setZeroBetSpinCounter(-1);
            Outsourced.soundPlayer.fadeOutMusic();
        }, '>0.5');
        if (!Outsourced.isWinBelowStake())
            tl.add(Outsourced.soundPlayer.playSoundBased("fsOutroCountUp"))
        tl.add(Outsourced.transitionScreen.showFreespinsOutro(wasSfs), '<');
        if (!Outsourced.isWinBelowStake())
            tl.add(Outsourced.soundPlayer.playSoundBased("fsOutroCountUpEnd"), '>-0.3')
        tl.add(Outsourced.soundPlayer.playLoopBased(wasSfs ? "sfsOutroLoop" : "fsOutroLoop"), '<')
        tl.add(Outsourced.transitionScreen.enableButton(() => this.onButtonClick(controller)));
        if (!Outsourced.isWinBelowStake())
            tl.add(Outsourced.soundPlayer.playSoundBased("fsOutroRevealStuff"));
        tl.add(() => {
            Outsourced.soundPlayer.stopSound("fsOutroCountUp");
            Outsourced.soundPlayer.stopSound("fsOutroCountUpEnd");
            controller.setSkipCallback()
        });
        tl.addLabel("SKIP_OUTRO")
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const activeBetFeature = SlotKeypad.apiPlugIn.betFeatureController.getActiveBetFeature();
        if (activeBetFeature?.name == "BOOSTED_BET")
            Outsourced.reelView.enableXBet()
        Outsourced.backgroundElements.setToBaseGame()
        Outsourced.reelView.setToNormal();
        Outsourced.transitionScreen.hideFreespinsOutro()
        Outsourced.soundPlayer.stopLoopBased("fsOutroLoop")
        Outsourced.soundPlayer.stopLoopBased("sfsOutroLoop")
        Outsourced.keypadPlugin.show();
        Outsourced.soundPlayer.switchMusic(GameMode.NORMAL);
        Outsourced.soundPlayer.fadeInMusic(0);
        controller.finish()

    }
}